/**
 * Created by liuchuanyang on 2017/2/14.
 */
import $ from 'jquery'
import videojs from 'video.js'

let audioPlayer
let prevAudioUrl

const RELATION_IS_SHARED = {
  default: 0,
  on: 1,
  off: 2
}

export default {
  projectStatus: ({ checkedStatus, isShared }, type) => {
    let label = ''
    let color = ''

    switch (checkedStatus) {
      case '00':
        label = '已发布'
        color = '#60ab08'
        break
      case '10':
        label = '待发布'
        color = '#f5a623'
        break
      case '11':
        label = '未通过审核'
        color = '#d0021b'
        break
      case '20':
        label = '正在审核'
        color = '#f5a623'
        break
      case '31':
        label = '已下线'
        color = '#f5a623'
        break
      case '32':
        label = '管理员下线'
        color = '#f5a623'
        break
    }

    if (type === 'bg') {
      return `<span style="background:${color};color:#FFF;padding: 2px 5px;" class="status">${label}</span>`
    }

    if (isShared === RELATION_IS_SHARED.on) {
      label = '共享'
    }

    return `<span style="color:${color}">${label}</span>`
  },
  itemStatus: (status, info) => {
    let label = ''
    let color = ''

    switch (status) {
      case 0:
        label = '待审核'
        color = '#f5a623'
        break
      case 1:
        label = '已通过'
        color = '#60ab09'
        break
      case 2:
        label = '未通过'
        color = '#d0021b'
        break
      default:
        label = '未通过'
        color = '#d0021b'
    }

    label = `<div><i style="color:${color}" class="fa fa-circle" aria-hidden="true"></i> ${label}</div>`

    // 通过不用显示理由
    if (status !== 1) {
      label += `<div>${info ? '原因：' + info : ''}</div>`
    }

    return label
  },
  itemType: (renderType, linkType) => {
    const label = []
    if (renderType === 1) {
      // 视频
      label.push('视频')
    }

    if (linkType === 1) {
      // 普通网页
      label.push('外网连接')
    } else if (linkType === 3) {
      // 自定义图文
      label.push('自定义图文')
    }

    return '<span style="color:#888">' + label.join(' + ') + '</span>'
  },
  thumb: (url, width, height, quality) => {
    width = width || 200
    height = height || 200
    quality = quality || 50
    return `${url}?imageView/2/w/${width}/h/${height}/q/${quality}/format/png`
  },
  playAudio: (url, event) => {
    if (!audioPlayer) {
      const $audio = $(`<video style="display:none;"></video>`).appendTo('body')

      audioPlayer = videojs(
        $audio[0],
        {
          language: 'zh-CN'
        },
        function () {
          // Player (this) is initialized and ready.
        }
      )
    }

    if (!url) {
      return
    }

    if (prevAudioUrl === url) {
      if (audioPlayer.paused()) {
        audioPlayer.play()
      } else {
        audioPlayer.pause()
      }
    } else {
      audioPlayer.src(url)
      audioPlayer.play()
    }

    prevAudioUrl = url
  },
  pauseAudio: () => {
    audioPlayer && audioPlayer.pause && audioPlayer.pause()
  },
  download: (url, fileName) => {
    const f = url.split('.')
    const ext = f[f.length - 1]
    window
      .fetch(url, {
        method: 'GET'
      })
      .then(res => res.blob())
      .then(blob => {
        var url = window.URL.createObjectURL(blob)
        var a = document.createElement('a')
        a.href = url
        a.download = fileName + '.' + ext
        a.click()
      })
  }
}
